/**
 * Webhook domain event schemas.
 *
 * Typed payload validation for all webhook-related Mycelium events.
 * Rule: fields added after initial release MUST be `.optional()`.
 *
 * @module webhook.events
 */

import { z } from 'zod'
import { BackboneEventSchema } from '../types/backbone.ts'

// ── Event schemas ───────────────────────────────────────────────────────

export const WebhookDeliveryRequestedEvent = BackboneEventSchema.extend({
  domain: z.literal('webhook'),
  type: z.literal('webhook_delivery_requested'),
  payload: z.object({
    sourceDomain: z.string(),
    sourceType: z.string(),
    sourceEventId: z.string().optional(),
    orgId: z.string().optional(),
    eventPayload: z.record(z.unknown()),
    originalTimestamp: z.string().optional(),
    source: z.string(),
  }),
})

// ── All webhook events ──────────────────────────────────────────────────

export const WebhookDomainEvents = [
  WebhookDeliveryRequestedEvent,
] as const
